var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-welcome-screen",
    },
    [
      _c("courseware-companion-box", {
        attrs: {
          msgCompanion: this.$gettext(
            "Es wurden bisher noch keine Inhalte eingepflegt."
          ),
        },
        scopedSlots: _vm._u([
          {
            key: "companionActions",
            fn: function fn() {
              return [
                _vm.canEdit && _vm.noContainers
                  ? _c(
                      "button",
                      {
                        staticClass: "button",
                        on: {
                          click: _vm.addNewContainer,
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$gettext("Einen Abschnitt hinzufügen")) +
                            "\n            "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }